import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '@/App';

// Cache for page contents to avoid repeated API calls
const contentCache = {};

export const usePageContent = (pageKey) => {
  const [sections, setSections] = useState(contentCache[pageKey]?.sections || {});
  const [loaded, setLoaded] = useState(!!contentCache[pageKey]);

  useEffect(() => {
    if (contentCache[pageKey]) {
      setSections(contentCache[pageKey].sections);
      setLoaded(true);
      return;
    }

    axios.get(`${API}/page-content/${pageKey}`)
      .then(res => {
        const data = res.data?.sections || {};
        contentCache[pageKey] = { sections: data };
        setSections(data);
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [pageKey]);

  // Helper: get section value with fallback
  const t = (key, fallback = '') => {
    return sections[key] || fallback;
  };

  return { sections, t, loaded };
};

export default usePageContent;
